import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vue",
  "use": "icon-vue-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vue\"><path d=\"M219.429 146.286v731.429c0 40 32 72 72 72h441.142c40 0 72-32 72-72V146.286c0-40-32-72-72-72H291.429c-40 0-72 32-72 72z\" fill=\"#4CAF50\" p-id=\"7426\" /><path d=\"M512 292.571L438.857 365.714 512 438.857l73.143-73.143L512 292.571zM365.714 438.857v146.286c0 40 32 72 72 72s72-32 72-72h-73.143c0 20-16 36-36 36s-36-16-36-36V438.857h73.143L365.714 438.857z\" fill=\"#FFFFFF\" p-id=\"7427\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol